import { Component } from '@angular/core';

@Component({
  selector: 'app-error-region',
  templateUrl: './error-region.component.html',
  styleUrls: ['./error-region.component.scss'],
})
export class ErrorRegionComponent {}
